import React, { useEffect, useState } from 'react';
import { countryByLanguage } from './language-display-info';

async function loadFlags() {
  const FlagsSquare = await import('country-flag-icons/react/1x1');
  const FlagsRectangle = await import('country-flag-icons/react/3x2');
  return { FlagsSquare, FlagsRectangle };
}

type Props = {
  localeCode?: string;
  countryCode?: string;
  shape?: 'circle' | 'square' | 'rectangle';
  width?: number;
  height?: number;
  style?: React.CSSProperties;
};

const defaultSize = 22;
function calculateDimensions(
  shape: Props['shape'],
  width?: number,
  height?: number,
): { w: number; h: number } {
  if (['circle', 'square'].includes(shape)) {
    return {
      w: width || height || defaultSize,
      h: width || height || defaultSize,
    };
  }
  return {
    w: width || ((height || defaultSize) * 3) / 2,
    h: height || (width * 2) / 3 || defaultSize,
  };
}

export default function FlagIcon({
  localeCode,
  countryCode,
  shape = 'circle',
  width,
  height,
  style = {},
}: Props) {
  const [flags, setFlags] = useState<{
    FlagsSquare: any;
    FlagsRectangle: any;
  } | null>(null);

  useEffect(() => {
    const load = async () => {
      const { FlagsSquare, FlagsRectangle } = await loadFlags();
      setFlags({ FlagsSquare, FlagsRectangle });
    };
    load();
  }, []);

  if (!flags || (!localeCode && !countryCode)) {
    return null;
  }
  const code = countryCode || countryByLanguage(localeCode);
  const Flag = ['circle', 'square'].includes(shape)
    ? flags.FlagsSquare[code]
    : flags.FlagsRectangle[code];
  const { w, h } = calculateDimensions(shape, width, height);

  return (
    <Flag
      width={w}
      height={h}
      className="language-icon"
      style={{
        border: '1px solid #eaeaea',
        borderRadius: 4,
        boxShadow: '0rem 5px 10px 0rem rgba(163, 178, 191, 0.3)',
        ...(shape === 'circle' && { borderRadius: '50%' }),
        ...style,
      }}
    />
  );
}
